import classNames from 'classnames/bind';
import { ReactNode } from 'react';
import styles from './CardButton.module.scss';

const cx = classNames.bind(styles);

export interface CardButtonProps {
  isActive?: boolean;
  className?: string;
  wrapperClassName?: string;
  children: ReactNode;
  onClick: () => void;
}

const CardButton = (props: CardButtonProps) => {
  const { isActive, className, wrapperClassName, children, onClick } = props;

  const handleClick = () => onClick();

  return (
    <div
      className={cx('card-button', wrapperClassName, {
        'card-button--active': isActive,
      })}
      onClick={handleClick}
    >
      <div className={cx('card-button__content', className)}>{children}</div>
    </div>
  );
};

export default CardButton;
